import React, { useMemo, useRef } from 'react';
import { ExperienceStart } from '@atlassian/experience-tracker';
import { ExperienceNames } from '../experience-tracker/ExperienceNames';
import { StyledIframe } from '../iframe';
import { useIntl } from 'react-intl-next';
export const StorageAccessPage = ({
  contentId,
  spaceKey,
  url,
  parentProduct
}) => {
  const {
    locale
  } = useIntl();
  const iframeRef = useRef(null);
  const src = useMemo(() => {
    const path = `/wiki/embed/storage-access?parentProduct=${parentProduct}&locale=${locale}`;
    const origin = url ? new URL(url).origin : window.location.origin;
    return [origin, path].join('');
  }, [locale, parentProduct, url]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ExperienceStart, {
    name: ExperienceNames.STORAGE_ACCESS_PAGE,
    id: `${spaceKey}-${contentId}`
  }), /*#__PURE__*/React.createElement(StyledIframe, {
    "data-testid": "storage-access-page-iframe",
    src: src,
    ref: iframeRef
  }));
};